import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

export default function ImpressumPage() {
  return (
    <div className="bg-[hsl(var(--surface-2))] py-12">
      <SEO
        title="Impressum"
        description="Impressum und Kontaktinformationen von ZO Werbeflächen – Ihr Partner für mobile Werbeflächen im Zürcher Oberland."
        canonicalPath="/imprint"
        noindex={false}
      />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <article className="bg-white rounded-xl border border-[hsl(var(--border))] p-8 sm:p-12 shadow-sm" data-testid="impressum-page">
            <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight mb-8">
              Impressum
            </h1>

            <div className="prose prose-sm sm:prose-base max-w-none space-y-6 text-[hsl(var(--foreground))]">
              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Angaben gemäss Schweizer Recht</h2>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Unternehmen</h2>
                <p className="leading-relaxed">
                  ZO Werbeflächen<br />
                  Bahnhofstrasse 75<br />
                  8620 Wetzikon<br />
                  Schweiz
                </p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Kontakt</h2>
                <p className="leading-relaxed">
                  Mobile: +41 79 696 98 99<br />
                  E-Mail: info@trucksonroad.ch
                </p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Vertretungsberechtigte Person(en)</h2>
                <p className="leading-relaxed">Geschäftsführer: Alexander Araujo</p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Handelsregistereintrag</h2>
                <p className="leading-relaxed">
                  Eingetragener Firmenname: ZO Werbeflächen<br />
                  Handelsregisteramt: Kanton Zürich<br />
                  UID: Folgt
                </p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Mehrwertsteuer</h2>
                <p className="leading-relaxed">
                  MWST-Nummer: Noch keine (UID Folgt)
                </p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Softwareplattform &amp; Technischer Betrieb</h2>
                <p className="leading-relaxed">
                  Diese Website sowie die zugrunde liegende Softwareplattform werden von der{' '}
                  <strong>InvictaX Group GmbH</strong> entwickelt, betrieben und lizenziert.
                  Die InvictaX Group GmbH ist verantwortlich für die technische Infrastruktur,
                  Softwareentwicklung, den Betrieb, die Wartung sowie die kontinuierliche
                  Weiterentwicklung der Plattform.
                </p>

                <div className="mt-4 space-y-1 leading-relaxed">
                  <p><strong>InvictaX Group GmbH</strong></p>
                  <p>Bahnhofstrasse 75</p>
                  <p>8620 Wetzikon (ZH)</p>
                  <p>Schweiz</p>
                </div>

                <div className="mt-4 space-y-1 leading-relaxed text-sm">
                  <p>Rechtsform: Gesellschaft mit beschränkter Haftung (GmbH)</p>
                  <p>Eintrag ins Handelsregister: 19.06.2026</p>
                  <p>Handelsregisteramt: Kanton Zürich</p>
                  <p>Handelsregister-Nummer: CH-020.4.092.608-3</p>
                  <p>UID: CHE-440.580.273</p>
                  <p>MWST-Nummer: CHE-440.580.273 MWST</p>
                </div>

                <p className="leading-relaxed mt-4">
                  Weitere Informationen:{' '}
                  <a
                    href="https://www.invictaflow.ch"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[hsl(var(--primary))] underline underline-offset-2"
                    data-testid="impressum-invictax-link"
                  >
                    www.invictaflow.ch
                  </a>
                </p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Haftungsausschluss</h2>
                <p className="leading-relaxed">Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.</p>
                <p className="leading-relaxed">Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.</p>
              </section>

              <section className="space-y-3">
                <h2 className="text-xl font-semibold mt-8">Urheberrechte</h2>
                <p className="leading-relaxed">Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf der Webseite gehören ausschliesslich ZO Werbeflächen oder den speziell genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.</p>
              </section>
            </div>
          </article>
        </motion.div>
      </div>
    </div>
  );
}
